import { _ as j } from "./objectWithoutPropertiesLoose-2ffc4b6d.js";
import { _ as s } from "./taggedTemplateLiteralLoose-b7a1029e.js";
import "./es.array.map-d821aaf5.js";
import "./es.object.assign-7e79fd7b.js";
import "./es.string.trim-6e13db75.js";
import { c as o } from "./index-8b07dec9.js";
import { forwardRef as M } from "react";
import { styled as l, css as n } from "styled-components";
import "./es.array.filter-4e9c9996.js";
import "./es.array.concat-d1c9b847.js";
import "./es.object.from-entries-0d7a0e54.js";
import "./es.object.entries-d2a19275.js";
import "./es.object.to-string-f55666a8.js";
import "./es.string.replace-f4cc3aea.js";
import "./es.array.is-array-7a29277f.js";
import "./web.dom-collections.for-each-3020ed11.js";
import { g as R } from "./getMetrics-953aa4f8.js";
import { Link as q } from "./link.js";
import { jsxs as D, jsx as i } from "react/jsx-runtime";
import "./export-cdcbfb2b.js";
import "./array-iteration-759bfbfa.js";
import "./create-property-f9780ed1.js";
import "./object-create-9b6715a2.js";
import "./object-keys-719a5561.js";
import "./html-32ef1b46.js";
import "./string-trim-14e37ad3.js";
import "./to-string-92a62764.js";
import "./classof-21a3574e.js";
import "./correct-is-regexp-logic-4465cd47.js";
import "./is-regexp-4c49b1c2.js";
import "./iterate-13ada9e5.js";
import "./object-to-array-0474b7e7.js";
import "./object-set-prototype-of-7d7e5736.js";
import "./function-uncurry-this-clause-99074d1c.js";
import "./function-apply-4756dee6.js";
import "./array-method-is-strict-e5a3c878.js";
import "./es.string.starts-with-a6645e0a.js";
import "./aria.js";
import "./index-5d0f31c6.js";
import "./es.object.keys-9d66766f.js";
import "./object-get-own-property-names-external-2f8b4cc4.js";
import "./array-slice-79f93c56.js";
import "./an-instance-6efcfd6c.js";
import "./check-correctness-of-iteration-7d57c70c.js";
import "./inherit-if-required-f068457b.js";
import "./define-built-in-accessor-26bc7b69.js";
import "./set-species-5ede2ed0.js";
import "./es.string.iterator-5de8a61e.js";
import "@ucl/shared-component-foundations";
import "@ucl/shared-icons";
import "./es.string.link-fd2676c6.js";
import "./string-html-forced-a746405b.js";
var z = ["titleProp", "disclosureItems", "globalDisclosureContent", "className", "returnToLinkTitle", "id", "disclosurePrefix"], A = ["disclosureText", "disclosureKey", "text", "disclosureNumber", "returnToLinkTitle"], P, k, C, I, O, y, $, E = l.div(P || (P = s([`
  &.TextDisclosure__wrapper {
    `, `;
  }
`])), function(e) {
  var t = e.theme, a = t.components.textDisclosure, p = t.componentStyles;
  return n(a.TextDisclosureWrapper, p);
}), F = l.div(k || (k = s([`
  &.TextDisclosure__items {
    `, `;
  }
`])), function(e) {
  var t = e.theme.components.textDisclosure;
  return n(t.TextDisclosureItems);
}), H = l.div(C || (C = s([`
  &.TextDisclosure__title {
    `, `;
  }
`])), function(e) {
  var t = e.theme.components.textDisclosure;
  return n(t.TextDisclosureTitle);
}), J = l.div(I || (I = s([`
  &.TextDisclosure__content-wrapper {
    `, `;
  }
`])), function(e) {
  var t = e.theme.components.textDisclosure;
  return n(t.TextDisclosureContentWrapper);
}), Q = l.div(O || (O = s([`
  &.TextDisclosure__bullet {
    `, `;
  }
`])), function(e) {
  var t = e.theme.components.textDisclosure;
  return n(t.TextDisclosureBullet);
}), U = l.div(y || (y = s([`
  &.TextDisclosure__content-container {
    `, `;
  }
`])), function(e) {
  var t = e.theme.components.textDisclosure;
  return n(t.TextDisclosureContentContainer);
}), V = l.div($ || ($ = s([`
  &.TextDisclosure__global {
    `, `;
  }
`])), function(e) {
  var t = e.theme.components.textDisclosure;
  return n(t.GlobalDisclosureWrapper);
}), Ue = /* @__PURE__ */ M(function(e, t) {
  var a, p = e.titleProp, x = p === void 0 ? {
    title: "Disclosure(s)",
    headingLevel: "h2"
  } : p, T = e.disclosureItems, v = T === void 0 ? [] : T, _ = e.globalDisclosureContent, b = e.className, r = b === void 0 ? "" : b, h = e.returnToLinkTitle, W = h === void 0 ? "Return to content" : h, f = e.id, N = e.disclosurePrefix, w = N === void 0 ? "Disclosure" : N, B = j(e, z), K = R({
    label: "TextDisclosure"
  });
  return /* @__PURE__ */ D(E, Object.assign({
    ref: t
  }, B, {
    id: f,
    className: o([r, "TextDisclosure__wrapper"])
  }, K, {
    children: [!!((a = x.title) != null && a.trim()) && /* @__PURE__ */ i(H, {
      className: o([r, "TextDisclosure__title"]),
      as: x.headingLevel,
      children: x.title
    }), !!_ && /* @__PURE__ */ i(V, {
      tabIndex: 0,
      className: o([r, "TextDisclosure__global"]),
      children: _
    }), v.length > 0 && /* @__PURE__ */ i(F, {
      className: o([r, "TextDisclosure__items"]),
      children: v.map(function(c, m) {
        var S = c.disclosureText, d = c.disclosureKey, g = c.text, u = c.disclosureNumber, L = c.returnToLinkTitle, G = j(c, A);
        return /* @__PURE__ */ D(J, {
          className: o([r, "TextDisclosure__content-wrapper"]),
          id: f + "-item-" + (u || d || m + 1),
          tabIndex: 0,
          "data-disclosure-content-number": u || d || m + 1,
          children: [/* @__PURE__ */ i(Q, {
            className: o([r, "TextDisclosure__bullet"]),
            children: (u || d || m + 1) + ")"
          }), /* @__PURE__ */ D(U, {
            className: o([r, "TextDisclosure__content-container"]),
            children: [/* @__PURE__ */ i("div", {
              children: g || S
            }), /* @__PURE__ */ i("div", {
              children: /* @__PURE__ */ i(q, Object.assign({}, G, {
                size: "xsmall",
                isDisclosureLink: !0,
                tabIndex: 0,
                "data-return-disclosure-number": u || m + 1,
                children: L || W + ", " + w + " " + (u || d || m + 1)
              }))
            })]
          })]
        }, m);
      })
    })]
  }));
});
export {
  Ue as TextDisclosure
};
